var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("UIButton", {
    class: _vm.customHeading,
    attrs: {
      buttonText: _vm.buttonText,
      variant: _vm.buttonVariant,
      size: _vm.buttonSize,
      processing: _vm.processing,
      fullWidth: _vm.fullWidth,
      buttonClasses: _vm.buttonClasses,
    },
    on: { click: _vm.add },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }